// Driver service status
export const DRIVER_STATUS_PENDING_IN_SERVICE = 0;
export const DRIVER_STATUS_IN_SERVICE = 1;
export const DRIVER_STATUS_OOS = 2;
export const DRIVER_STATUS_TERMINATED = 3;
export const DRIVER_STATUS_PENDING_TERMINATION = 4;

// Equipment Categories
export const EQ_CATEGORY_CHASSIS = 2;

// Stop Types
export const STOP_TYPE_CHASSIS_SPLIT = 1;
export const STOP_TYPE_DELIVERY = 2;
export const STOP_TYPE_PICKUP = 3;
export const STOP_TYPE_REJECTED = 4;
export const STOP_TYPE_STOPOFF = 8;
export const STOP_TYPE_TERMINATE = 10;
export const STOP_TYPE_GROUNDED = 14;

// Move Types
export const MOVE_TYPE_DOMESTIC = 0;
export const MOVE_TYPE_EXPORT = 1;
export const MOVE_TYPE_IMPORT = 2;
export const MOVE_TYPE_RTP = 3;
export const MOVE_TYPE_REPO = 4;
export const MOVE_TYPE_OUTBOUND = 5;
export const MOVE_TYPE_INBOUND = 6;
export const MOVE_TYPE_CONTAINER_MANAGEMENT = 7;
export const MOVE_TYPE_DOMESTIC_RAIL_IMPORT = 8;
export const MOVE_TYPE_DOMESTIC_RAIL_EXPORT = 9;

// Grounding Location
export const GROUNDING_STATUS_BOTH = 2;
export const GROUNDING_STATUS_NO = 0;
export const GROUNDING_STATUS_YES = 1;

// Location Types
export const LOCATION_TYPE_GWI = 1;

// Markets
export const MARKET_ID_HOUSTON = 1;
export const MARKET_ID_DALLAS = 2;
export const MARKET_ID_MOBILE = 3;

// Scheduling terminals
export const SCHEDULING_TERMINAL_ID_HOUSTON = 2;

// Truck Types
export const TRUCK_TYPE_STANDARD = 0;
export const TRUCK_TYPE_DAY_CAB = 1;
export const TRUCK_TYPE_MULE = 2;

// Surcharge Types
export const SURCHARGE_PERCENTAGE = 0;
export const SURCHARGE_PER_MILE = 1;
export const SURCHARGE_FLAT = 2;

export const AUTO_POPULATION = {
  DROP_PICK: 0,
  OTR: 1,
  WEIGHT_RULE: 2,
  ORG_TARIFF: 3,
};

// Scheduling terminal pool types
export const POOL_TYPES = {
  SEPARATE: 0,
  COMBINED: 1,
};

// Organization Roles
export const BILLTO_ORGANIZATION_ROLE = 1;
export const CUSTOMER_ORGANIZATION_ROLE = 0;
export const BROKER_ORGANIZATION_ROLE = 2;
export const CHASSIS_PROVIDER_ROLE = 4;
export const SSL_ROLE = 5;

// Yes/No dropdowns
export const YES_NO_DATASET = [
  { description: 'No', value: false },
  { description: 'Yes', value: true },
];

// Equipment Subcategory Types
export const EQUIPMENT_SUBCATEGORY_TYPES = {
  REEFER: 100,
  REEFER_WITH_GENSET: 101,
  REEFER_HC: 102,
  REEFER_HC_WITH_GENSET: 103,
  ISO_TANK: 104,
  REEFER_VAN: 300,
  REEFER_VAN_WITH_GENSET: 301,
};

// Out of service reasons' types
export const DRIVER_OOS_REASON_TYPE = 1;
export const TRUCK_OOS_REASON_TYPE = 2;
export const SHARED_OOS_REASON_TYPE = 3;

// Dispatched driver state
export const NOT_ACCEPTED_DISPATCHED_STATE = 0;
export const ACCEPTED_DISPATCHED_STATE = 1;
export const IN_TRANSIT_DISPATCHED_STATE = 3;
export const PLANNED_DISPATCHED_STATE = 4;
export const NOT_ASSIGNED_DISPATCHED_STATE = 5;
export const COMPLETED_DISPATCHED_STATE = 6;
